if (!customElements.get('experience-slider')) {
  class ExperienceSlider extends HTMLElement {
    constructor() {
      super();
    }

    init() {
      this.slider = new Swiper(this.querySelector('[js-slider]'), {
        loop: true,
        spaceBetween: 26,
        slidesPerView: 'auto',
        centeredSlides: true,
        watchOverflow: true,
        navigation: {
          nextEl: this.querySelector('[js-slider-next]'),
          prevEl: this.querySelector('[js-slider-prev]'),
        },
      });
    }

    destroy() {
      if(!this.slider) return;

      this.slider.destroy();
    }

    handleChange(event) {
      if(this.media.matches) return this.init();

      return this.destroy();
    }

    connectedCallback() {
      this.media = window.matchMedia("(max-width: 989px)");
      this.media.addEventListener('change', this.handleChange.bind(this));

      this.handleChange();
    }
  }

  customElements.define('experience-slider', ExperienceSlider);
}
